import React from 'react';
import { styled } from '@guest-widgets/core';
import Button from '@mui/material/Button';
import { Text } from '@eo-locale/react';
import { classes } from '@guest-widgets/shared/src/classes';

import { useFilters } from '../../filtersContext/filtersContext';

export const ResetAllButton = () => {
  const { resetFilters } = useFilters();

  return (
    <StyledButton
      className={classes.catalog.filters.applied.reset}
      onClick={resetFilters}
      size="small"
      color="secondary"
    >
      <Text id="product-catalog.filters.reset-all" />
    </StyledButton>
  );
};

const StyledButton = styled(Button)(({ theme: { spacing, typography }, widgetArea }) => ({
  textDecoration: 'underline',
  margin: spacing(0, widgetArea.basedOnSize(0, 0, 4)),
  textTransform: 'none',
  fontSize: typography.caption.fontSize,
}));
